import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import '../TwoLineEllipses/TwoLineEllipsesWrapper.scss';

const TwoLineEllipsis = ({ children }) => {
  const truncatedRef = useRef(null);
  const tooltipRef = useRef(null);

  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (truncatedRef?.current && tooltipRef?.current) {
        setIsTruncated(truncatedRef.current.offsetHeight !== tooltipRef.current.offsetHeight)
      }
    }, 500) // apply delay to allow the tooltip to render
  }, []);

  return (
    <div className="two-line-ellipsis-wrapper">
      <div
        className={`two-line-ellipsis ${isTruncated ? 'truncated' : ''}`}
        ref={truncatedRef}
      >
        {children}
      </div>
      <div className={`ellipsis-tooltip-container ${isTruncated ? 'truncated' : ''}`}>
        <div className="ellipsis-tooltip" ref={tooltipRef}>
          {children}
        </div>
      </div>
    </div>
  );
};

TwoLineEllipsis.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TwoLineEllipsis;
